// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__6B5Fe","header":"Header_header__B-kdC"};